import template from './terms-page.html';

export default {
  template,
  controller: 'TermsPageController',
};



// WEBPACK FOOTER //
// ./src/modules/terms-preview/components/terms-page/terms-page-component.js